import Vue from 'vue'
import Vuex from 'vuex'
import {apiUrls} from "./urls";
import home from "./modules/home"

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    home
  },

  state: {
  },

  actions: {
  },

  mutations: {
    setData(state, {key, value, module = false}) {
      if (module) return (state[module][key] = value);

      state[key] = value;
    }
  },

})
